







import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import { InjectReactive } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import TextWrapper from '@/modules/shared/components/shared/TextWrapper.vue'
import { ProfitType } from '@/modules/profit/models/profit-resource.model'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminProfitIndexPageTableActions
  from '@/modules/profit/components/admin/table/AdminProfitIndexPageTableActions.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminProfitIndexPageTableRow extends mixins(TesTableRow) {
  @InjectReactive() fixedData

  columnComponents = {
    description: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    profitable_type: {
      component: TextWrapper,
      handler: (value, row, fixedData) => ({ text: fixedData.profitable_types[value], class: 'inline-block' })
    },
    type: {
      component: TextWrapper,
      handler: (value, row, fixedData) => ({
        text: fixedData.types[value],
        class: [value === ProfitType.INCREASE ? 'text-tes-green' : 'text-tes-red', 'inline-block']
      })
    },
    created_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    actions: {
      component: AdminProfitIndexPageTableActions,
      handler: (_, row, fixedData) => ({ profitResource: row, profitFixedData: fixedData })
    }
  }
}
